import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { RevenueForecast } from '../../types/admin/AdminTypes';

interface RevenueForecastCardProps {
  forecast: RevenueForecast[];
}

const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  }).format(value);
};

const RevenueForecastCard: React.FC<RevenueForecastCardProps> = ({ forecast }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid #e0e0e0'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <TrendingUpIcon sx={{ color: '#1976d2' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Previsão de Receita (próximos 6 meses)
        </Typography>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, color: 'text.secondary' }}>Mês</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600, color: '#f44336' }}>Pessimista</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600, color: 'text.primary' }}>Previsto</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600, color: '#4caf50' }}>Otimista</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {forecast.map((row) => (
              <TableRow key={row.month} sx={{ '&:last-child td': { border: 0 } }}>
                <TableCell>{row.month}</TableCell>
                <TableCell align="right" sx={{ color: '#f44336' }}>
                  {formatCurrency(row.pessimistic)}
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>
                  {formatCurrency(row.predicted)}
                </TableCell>
                <TableCell align="right" sx={{ color: '#4caf50' }}>
                  {formatCurrency(row.optimistic)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default RevenueForecastCard;
